import SelectTab from './select-tab.vue';
export default SelectTab;
